import { type SVGIconProps } from "@repo/icons";
import type { FunctionComponent, InputHTMLAttributes } from "react";
import React from "react";

export interface CpsLinedDataProps extends InputHTMLAttributes<HTMLInputElement> {
  Icon?: FunctionComponent<SVGIconProps>;
  children?: React.ReactNode;
  hideIcon?: boolean;
}

/**
 * `CpsLinedData` is a component that renders an line field with an icon and a text.
 *
 *
 * @example
 * Here is a basic usage example:
 * ```tsx
 * <CpsLinedData text="Example" icon={Example} />
 * ```
 * @param Icon - The icon to be displayed in the start of the line field.
 * @param text - The text of the line field.
 *
 * @returns The `CpsLinedData` component.
 */

export const CpsLinedData = ({ Icon, children, hideIcon = false }: CpsLinedDataProps) => {
  return (
    <div className="flex flex-row items-center gap-4 w-full">
      {Icon && !hideIcon ? (
        <Icon className="fill-secondary-400" size={24} />
      ) : (
        <div style={{ height: "24px", width: "24px" }}> </div>
      )}
      <div className="overflow-hidden break-all w-full">
        <span className="text-md font-medium leading-6 text-neutral-500 xl:text-xl">
          {children}
        </span>
      </div>
    </div>
  );
};

export default CpsLinedData;
